import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function tenureDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/tenure/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
